import SiteType from "types/SiteType";

const { BUSINESS, COJP } = SiteType;
const COJP_URL = /^(.+\.)?bloomberg\.co\.jp$/i;
const ONSITE_URLS = [
    /^(.+\.)?bloomberg\.com$/i,
    /^(.+\.)?bloombergradio\.com$/i,
    COJP_URL
];

function isOnSite(hostname) {
    return ONSITE_URLS.some(regex => regex.test(hostname));
}

function getSiteName(hostname) {
    return COJP_URL.test(hostname) ? COJP : BUSINESS;
}

export default {
    isOnSite,
    getSiteName
};
